import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, styled } from "@mui/material";
import { BankRow } from "./BankRow";
import { BankData, BankRowData } from "./types";

const Card = styled("div")(({ theme }) => ({
  border: `1px solid ${theme.palette.border.secondary}`,
  borderRadius: 10,
  overflow: "hidden",
  backgroundColor: theme.palette.background.subtle,
  color: theme.palette.text.secondary,
}));

const Item = styled("div")(({ theme }) => ({
  padding: theme.spacing(3, 4),
  borderTop: `1px solid ${theme.palette.border.secondary}`,
}));

const sections: (keyof BankRowData)[] = ["depot", "account"];

interface Props {
  banks: BankRowData[];
}

export const BanksMobileList = ({ banks }: Props) => {
  const { t } = useTranslation();

  return (
    <Card data-testid="banks-mobile-list">
      {sections.map((section) => {
        const items = banks
          .map((row) => row[section])
          .filter((bank): bank is BankData => bank !== undefined);
        if (!items.length) return null;
        return (
          <Box
            key={section}
            component="section"
            aria-labelledby={`csv-banks-${section}`}
          >
            <Typography
              id={`csv-banks-${section}`}
              variant="body4"
              color="textPrimary"
              component="h3"
              px={4}
              py={3}
            >
              {t(`csvImport.banksTable.${section}`)}
            </Typography>
            {items.map((bank) => (
              <Item key={bank.name}>
                <BankRow bank={bank} />
              </Item>
            ))}
          </Box>
        );
      })}
    </Card>
  );
};
